import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-center mt-2"
};
const _hoisted_2 = { class: "mt-2" };
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    key: 0,
    class: "mt-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (!_ctx.$store.state.isCliente())
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("div", null, "La tua qualifica:", -1)),
            _createElementVNode("div", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.$store.state.loginResponse.qualifica), 1)
            ]),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                    class: "immagineQualifica",
                    src: _ctx.getQualificaImg()
                }, null, 8, _hoisted_3)
            ]),
            (_ctx.giorniAlPassaggio && !_ctx.$store.state.isCommerciale())
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createTextVNode(_toDisplayString(_ctx.giorniAlPassaggio) + " gg al ", 1),
                    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                    _cache[1] || (_cache[1] = _createTextVNode("passaggio di livello "))
                ]))
                : _createCommentVNode("", true)
        ]))
        : _createCommentVNode("", true);
}
